import React, { useState, Suspense } from 'react'
import { Box } from '@mui/system'
import { AppBar, Tab, Tabs, Typography } from '@mui/material'
import { useStyles } from './ReportingStyles'
import { TabPanelProps } from '../../interfaces/inbox'
import { LoadBalancerLog } from './LoadBalancerLog'
import { CaseCounts } from './CaseCounts'
import { QCAssignment } from './QCAssignment'
import { ReportUpload } from './ReportUpload'

function a11yProps(index: unknown) {
  return {
    id: `Reporting-${index}`,
    'aria-controls': `Reporting-${index}`,
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`Reporting-${index}`}
      aria-labelledby={`Reporting-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0} pt={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
export function Reporting({ role, user }): JSX.Element | null {
  const classes = useStyles()
  const [value, setValue] = useState(0)

  // eslint-disable-next-line @typescript-eslint/ban-types
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (newValue === undefined) return
    setValue(newValue)
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Box className={classes.mt}>
        <AppBar position="static" className={classes.appBar}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Reporting"
            classes={{
              indicator: classes.indicator,
            }}
          >
            <Tab label="Load balancer log" {...a11yProps(0)} />
            <Tab label="QC Load Balancer log" {...a11yProps(1)} />
            <Tab label="Report Upload log" {...a11yProps(2)} />
            <Tab label="Completed Case Counts" {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <LoadBalancerLog user={user} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <QCAssignment user={user} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ReportUpload user={user} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <CaseCounts user={user} />
        </TabPanel>
      </Box>
    </Suspense>
  )
}
